import { React, useState, useEffect, useRef, useContext } from "react";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
  DownArrowDraw,
  HaberForm,
} from "../../styledElements";
import { Button, Form, Input, PageHeader, Select, Table, Tooltip } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { Styled } from "../../pageStyled";
import { useNavigate, Link } from "react-router-dom";
import OrderSummaryHeader from "./orderSummaryTableHeader";
import warning from "../../../Assets/Icons/warning.png";
import { ModalPopup } from "../../../Components/Modal/modal";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import {
  deleteJobCard,
  getJobCards,
  postGroups,
  getAlgorithmCompletionStatus,
  searchDeckleMatchGroups,
  deleteGroup,
  cancelJobCard,
  postSheetGroups,
  postDuplexGroups,
  editCoreIdForOrderSummary,
  postGroupsMultistage,
  mergeGroups,
  editToleranceForOrderSummary,
} from "../../../Services/deckleMatchServices";
import axios from "axios";
import { useLocation } from "react-router-dom";
import ConfirmationModal from "../../../Components/Modal/ConfirmationModal";
import MergedOrder from "../../DeckleMatching/DeckleOrderDrawer/mergeOrder";
import ViewMergeDrawer from "../../DeckleMatching/DeckleOrderDrawer/viewMergedOrder";
import {
  getMergeGroupsData,
  setMergeGroupsData,
} from "../../../Services/mergeGroupServices";
import { seperateGroups } from "../../../Services/deckleMatchServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import { getFormObject, setFormObject } from "../../../Services/formServices";
import styled from "styled-components";
import {
  lengthUnit,
  weightUnit,
  currency_List,
  orderDim_Rewinder_Unit_Conversion,
  CoversionFactorUnitsToCM,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getReelCoreValues } from "../../../Services/settingsServices";
import { Option } from "antd/lib/mentions";
import { useForm } from "antd/lib/form/Form";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer.jsx";
import JobCardDataContext from "../../../ContextApi/JobCardDataContext";
import ToleranceEditModal from "../../../Components/Modal/ToleranceEditModal.jsx";
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

function onChange(pagination, filters, sorter, extra) {
  //console.log("params", pagination, filters, sorter, extra);
}
const SelectStyle = styled.div`
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    margin-top: 10px;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    padding-left: 3px;
    padding-right: 10px;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: none;
  }
`;

const OrderSummaryData = (props) => {
  const {
    orderSummaryTable,
    handleResetAll,
    stopCancelled,
    setStopCancelled,
    setOrderSummaryTable,
    setAcceptedJCGrpCode,
  } = useContext(JobCardDataContext);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [jobCards, setJobCards] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const routerLocation = useLocation();

  const location =
    Object.keys(orderSummaryTable).length > 0
      ? orderSummaryTable
      : routerLocation
  // console.log('routerLocation',routerLocation,location);
  const [data, setData] = useState(
    // getMergeGroupsData() || 
    location.state?.data
  );
  const [finalData, setFinalData] = useState(
    // getMergeGroupsData() ||
    location.state?.data
  );
  const [viewCancelModal, setViewCancelModal] = useState(false);
  const [viewMergeModal, setViewMergeModal] = useState(false);
  const [viewMergeMultipleModal, setViewMergeMultipleModal] = useState(false);
  const [mergeorderDrawer, setMergeorderDrawer] = useState(false);
  const [viewMergedorderDrawer, setViewMergedorderDrawer] = useState(false);
  const [selectedMergeOrderGroup, setSelectedMergeOrderGroup] = useState();
  const [currentViewMerge, setCurrentViewMerge] = useState();
  const [confirmRemoveGroups, setConfirmRemoveGroups] = useState(false);
  const [mergedBool, setMergedBool] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  // const [retainForm,setRetainForm] = useState(true);
  const nextClickRef = useRef(false);
  const isCancelJobCard = useRef(true);
  const [formValues, setFormValues] = useState(getFormObject());
  const [loadings, setLoadings] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editedCoreDia, setEditedCoreDia] = useState("");
  const [selectedRecord, setSelectedRecord] = useState();
  const [isSaveButtonVisible, setIsSaveButtonVisible] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageMulti, setErrorMessageMulti] = useState("");
  const [coreValues, setCoreValues] = useState();
  const [newCoreId, setNewCoreId] = useState("");
  const [minimumReelOd, setMinimumReelOd] = useState(0);
  const [minimumReelOdAllGroups, setMinimumReelOdAllGroups] = useState(0);
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [mergeMultipleGroups, setMergeMultipleGroups] = useState(null);
  const [selectedCoreId, setSelectedCoreId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let algorithmPollingStatus;
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [visibleTolerancePopUp, setVisibleTolerancePopUp] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [selectedToleranceLevelType, setSelectedToleranceLevelType] =
    useState();

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 4000);
  };
  const [scrollPosition, setScrollPosition] = useState({
    scrollX: 0,
    scrollY: 0,
  });
  /* ****** */
  const isViewClick = useRef(false);
  const [headerForm] = useForm();

  const titleRef = useRef(null);
  const [stickyOffsets, setStickyOffsets] = useState({ title: 58, table: 110 });

  useEffect(() => {
    const observer = new ResizeObserver(() => {
      const baseTop = 58;
      const titleHeight = titleRef.current?.offsetHeight || 0;

      setStickyOffsets({
        title: baseTop,
        table: baseTop + titleHeight
      });
    });

    if (titleRef.current) observer.observe(titleRef.current);

    return () => observer.disconnect();
  }, [data]);
  const getCurrentScrollPositionByClick = (e) => {
    isViewClick.current = true;
    let cordsAfterClick = {};
    let cords = ["scrollX", "scrollY"];
    cords.forEach((cord) => {
      cordsAfterClick[cord] = window[cord];
    });
    localStorage.setItem("scrollCords", JSON.stringify(cordsAfterClick));
  };
  const [isNextDisaled, setIsNextDisabled] = useState(false);

  const PendingDetails = styled.div`
    .pendingDetailsStyle {
      display: block;
      text-align: right;
      padding-bottom: 16px;
      font-size: 14px;
      font-family: var(--sf-pro-display-m);
      color: var(--theme-color);
      line-height: 16px;
    }
    .pendingOrderStyle {
      padding-right: 20px;
    }
  `;
  // useEffect(()=>{
  //   return () => {
  //     if(!retainForm) {
  //       setFormObject(null); //to clear paper machine form data
  //     }
  //   };
  // },[retainForm])

  const handleEditColumn = (value, record) => {
    setEditMode(value);
    setSelectedRecord(record);
    // console.log(record);
    setMinimumReelOd(record?.min_reel_od);
    if (!editMode) {
      setEditedCoreDia(record.core_id);
    }
    setIsSaveButtonVisible(true);
  };

  const handleToleranceEditColumn = (record) => {
    if (record.toleranceLevel && record.toleranceLevel == "Job Card") {
      setVisibleTolerancePopUp(true);
      setSelectedRecord(record);

      setSelectedToleranceLevelType(
        record.toleranceLevel ? record.toleranceLevel : "jobcard_level"
      );
    }
    else {
      handleViewAction(record)
    }
  };

  const handleCoreOD = (value) => {
    console.log("Hii", value);
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    const floatVal =
      parseFloat(value?.split(" ")[0]) * parseFloat(coreodConversion);
    if (floatVal >= minimumReelOd) {
      setErrorMessage("Core ID can't be greater than Reel OD");
      return;
    }
    setNewCoreId(value);
    setErrorMessage("");
    // console.log(
    //   data.total_production_quantity,
    //   data.total_production_weight,
    //   data.total_selected_orders,
    //   selectedRecord
    // );
  };

  const handleMultiCoreOD = (value) => {
    console.log("val", value)
    let coreodConversion =
      orderDim_Rewinder_Unit_Conversion[value?.split(" ")[1]];
    const floatVal =
      parseFloat(value?.split(" ")[0]) * parseFloat(coreodConversion);
    if (floatVal >= minimumReelOdAllGroups) {
      setErrorMessageMulti(
        "Few groups have reel dia less than the selected core dia. Please change the core dia value or update the groups individually."
      );
      return;
    }
    handleMultiCoreSave(value);
    setErrorMessageMulti("");
  };
  const handleSave = async (isMergeTrue = false, isMultiple, multiCore) => {
    if ((newCoreId === "" && !isMultiple) || (isMultiple && !multiCore)) {
      setErrorMessage("Please select a valid Core Dia");
      return;
    }
    setIsNextDisabled(true);
    const [coreId, units] = isMultiple
      ? multiCore.split(" ")
      : newCoreId.split(" ");

    //only for single group where same core id exists.
    const filterSameGroups = isMultiple
      ? []
      : data.groups
        .filter(
          (group) =>
            group.id != selectedRecord.id &&
            group.core_id * CoversionFactorUnitsToCM[data?.units?.core_id] ===
            parseFloat(coreId) * CoversionFactorUnitsToCM[units] &&
            group.product.code === selectedRecord.product.code &&
            group.ply === selectedRecord.ply
        )
        .map((group) => group.id);

    if (filterSameGroups.length && !isMergeTrue) {
      setViewMergeModal(true);
      return;
    }

    //for multiple groups with same core id
    const mergeMultiple =
      isMultiple &&
      mergeMultipleGroups === null &&
      data.groups.some((group, index) => {
        for (let i = index + 1; i < data.groups.length; i++) {
          const otherGroup = data.groups[i];
          if (
            group.id !== otherGroup.id &&
            // group.core_id * CoversionFactorUnitsToCM[data?.units?.core_id] ===
            //   otherGroup.core_id * CoversionFactorUnitsToCM[units] &&
            group.product.code === otherGroup.product.code
          ) {
            return true;
          }
        }
        return false;
      });

    if (mergeMultiple) {
      setViewMergeMultipleModal(true);
      return;
    }

    const groupIdArray = isMultiple
      ? data?.groups?.map((gr) => gr.id)
      : [selectedRecord.id];
    const requestBody = {
      core_id: parseFloat(coreId),
      units: {
        core_id: units,
      },
      id: groupIdArray,
      total_selected_orders: data.total_selected_orders,
      total_production_quantity: data.total_production_quantity,
      total_production_weight: data.total_production_weight,
      merge_groups: mergeMultipleGroups ? mergeMultipleGroups : false,
    };
    const mergeRequest = isMultiple
      ? {}
      : {
        product: selectedRecord.product.code,
        groups: [...filterSameGroups, selectedRecord.id],
        optional_groups: [],
        inner_dia: newCoreId,
      };

    if (isMergeTrue) {
      setIsLoading(true);
      await mergeGroups(mergeRequest, true)
        .then((resp) => {
          setData({
            groups: resp.groups,
            total_production_quantity: resp.total_production_quantity,
            total_selected_orders: resp.total_selected_orders,
            total_production_weight: resp.total_production_weight,
            units: resp.units,
          });
          setOrderSummaryTable((prevState) => ({
            ...prevState,
            state: {
              ...prevState.state,
              data: {
                groups: resp.groups,
                total_production_quantity: resp.total_production_quantity,
                total_selected_orders: resp.total_selected_orders,
                total_production_weight: resp.total_production_weight,
                units: resp.units ? resp.units : {},
              }, // <-- replace `newData` with your updated value
            },
          }));
          setFinalData({
            groups: resp.groups,
            total_production_quantity: resp.total_production_quantity,
            total_selected_orders: resp.total_selected_orders,
            total_production_weight: resp.total_production_weight,
            units: resp.units,
          });
          setActionToaster({
            error: resp.error,
            msg: `Changes are successfully saved`,
          });
          showToaster();
          setSelectedRecord();
          setErrorMessage("");
          setNewCoreId("");
          toggleEditMode();
        })
        .catch((mergeError) => {
          setActionToaster({
            error: mergeError.response?.data?.error,
            msg: mergeError.response?.data?.msg,
          });
          showToaster();
          console.error("Merge Error:", mergeError);
        })
        .finally(() => {
          setViewMergeModal(false);
          setIsNextDisabled(false);
          setIsLoading(false);
        });
      return;
    }
    if (isMultiple) setIsLoading(true);
    await editCoreIdForOrderSummary(requestBody)
      .then((response) => {
        setActionToaster({
          error: response.error,
          msg: `Changes are successfully saved`,
        });

        let groupData = isMultiple
          ? response?.data?.groups
          : // ?.filter((gr) => {
          //   return groupIdArray.findIndex((grId) => grId == gr.id) !== -1;
          // })
          data.groups.map((group) => {
            if (group.id == selectedRecord.id) {
              return response?.data?.groups.filter(
                (gr) => gr.id == selectedRecord.id
              )[0];
            }
            return group;
          });

        setData({
          groups: groupData,
          total_production_quantity: response?.data?.total_production_quantity,
          total_selected_orders: response?.data?.total_selected_orders,
          total_production_weight: response?.data?.total_production_weight,
          units: response?.data?.units,
        });
        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState.state,
            data: {
              groups: groupData,
              total_production_quantity: response?.data?.total_production_quantity,
              total_selected_orders: response?.data?.total_selected_orders,
              total_production_weight: response?.data?.total_production_weight,
              units: response?.data?.units,
            }, // <-- replace `newData` with your updated value
          },
        }));
        setFinalData({
          groups: groupData,
          total_production_quantity: response?.data?.total_production_quantity,
          total_selected_orders: response?.data?.total_selected_orders,
          total_production_weight: response?.data?.total_production_weight,
          units: response?.data?.units,
        });
        // isMultiple && searchGroups(searchQuery);
        setSelectedRecord();
        setErrorMessage("");
        setNewCoreId("");
      })
      .catch((error) => {
        setActionToaster({
          error: error?.response?.data?.error,
          msg: error?.response?.data?.msg,
        });
        console.error("Error:", error);
      })
      .finally(() => {
        showToaster();
        setMergeMultipleGroups(null);
        setIsLoading(false);
      });
    setIsNextDisabled(false);
  };

  // useEffect(() => {}, data);

  const toggleEditMode = () => {
    setEditMode(!editMode);
    if (!editMode) {
      setEditedCoreDia(selectedRecord.core_id);
    }
  };
  const handleDiscard = () => {
    setNewCoreId("");
    setSelectedRecord();
    setErrorMessage("");
    toggleEditMode();
  };

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setEditedCoreDia(newValue);
    if (!isNaN(newValue) && parseFloat(newValue) > 0) {
      setErrorMessage("");
      setIsSaveButtonVisible(true);
    } else {
      if (isNaN(newValue)) setErrorMessage("Please enter a number");
      else setErrorMessage("Please enter a positive non zero value");
      setIsSaveButtonVisible(false);
    }
  };

  const handleResetTolerance = async (record) => {
    try {
      const body = {
        group: record?.id,
        type: "reset",
        upper_tolerance: null,
        lower_tolerance: null,
        order: record?.orders.map(String),
        units: { "weight": location?.state?.data?.units?.weight }
      }
      const response = await editToleranceForOrderSummary(body)
      if (!response?.data?.err) {
        const updatedGroupsData = data.groups.map((group) => {
          if (group.id == record.id)
            return { ...group, lower_bound_percentage: null, upper_bound_percentage: null }
          else
            return group
        })
        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState.state,
            data: {
              ...prevState.state.data,
              groups: updatedGroupsData,
            }
          },
        }));
        setData({ ...data, groups: updatedGroupsData });
        setFinalData({ ...finalData, groups: updatedGroupsData });
        setActionToaster({
          error: response.data?.err,
          msg: `Tolerance Reset Done`
        })
        showToaster()
      }
    }
    catch (e) {
      console.log(e)
    }
  }

  const handleToleranceLevelChange = (e, record) => {
    record["toleranceLevel"] = e;
    if (
      record.toleranceLevel == "Job Card" &&
      (!record.lower_bound_percentage || !record.upper_bound_percentage)
    ) {
      handleToleranceEditColumn(record);
    }

    // record.toleranceLevel = "Order";
    let groups = data.groups;
    let selectedGroup = groups.map((group) =>
      group.id === record.id
        ? {
          ...group,
          toleranceLevel: e,
        }
        : group
    );
    setData((prevState) => ({
      ...prevState,
      groups: selectedGroup,
    }));
    setOrderSummaryTable((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        data: {
          ...prevState.state.data,
          groups: selectedGroup,
        }
      },
    }));
  };

  const columnsHead = [
    {
      title: "S.No",
      width: "6%",
      render: (text, record, index) => index + 1,

      align: "center",
    },
    {
      title: "Product Specifications",
      dataIndex: "product",
      width: "20%",
      // sorter: {
      //   compare: (a, b) => a.product_specfications - b.product_specfications,
      // },
      render: (data, record) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {data.product_spec}
          {record.show_merged_tag && (
            <span className="taged" dataset="Produced">
              Merged Orders
            </span>
          )}
        </span>
      ),
    },

    {
      title: "No. of orders",
      dataIndex: "number_of_orders",
      width: "12%",
      sorter: {
        compare: (a, b) => a.number_of_orders - b.number_of_orders,
      },
      align: "center",
    },
    ...(location.state.processType == "singleStage" &&
      location.state.body.machine_type == "rewinder"
      ? [
        {
          title: "Ply",
          dataIndex: "ply",
          width: "5%",
        },
      ]
      : []), // Conditional column
    {
      title: "Planned Weight",
      dataIndex: "weight",
      width: "13%",
      align: "center",
      render: (item) =>
        item
          ? item?.toFixed(3) +
          " " +
          capitalize(weightUnit[data?.units?.planned_weights]?.displayName)
          : null,
    },
    {
      title: "Tolerance Level",
      dataIndex: "toleranceLevel",
      width: "8%",
      align: "left",
      render: (item, record) => (
        <>
          <SelectStyle
            style={{
              width: "100%",
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span>
              <Form.Item
                name="tolerance_level"
                rules={[]}
                className="selectForm"
                style={{ marginBottom: 4 }}
              >
                <Select
                  suffixIcon={<DownArrowDraw />}
                  key={record?.toleranceLevel}
                  showSearch={false}
                  optionFilterProp="children"
                  onChange={(e) => handleToleranceLevelChange(e, record)}
                  defaultValue={record?.toleranceLevel || 'Order'}
                  //value={record?.toleranceLevel }
                  style={{ width: "100px" }}
                >
                  {["Order", "Job Card"]?.map((data) => (
                    <Option key={data}>{data}</Option>
                  ))}
                </Select>
              </Form.Item>
            </span>

            <>
              <Tooltip
                placement="bottomRight"
                title={"Edit tolerance level"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleToleranceEditColumn(record);
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    // float: "right",
                    marginLeft: "6px"
                  }}
                >
                  <Iconmoon icon="edit" size={14} color="#A19F9D" />
                </Button>
              </Tooltip>
              {/* {record.toleranceLevel != "Job Card" && ( */}
              <Tooltip
                placement="bottomRight"
                title={"Reset tolerance level"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleResetTolerance(record);
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    // float: "right",
                    paddingLeft: "6px",
                    visibility: (record?.toleranceLevel == "Job Card") ? "hidden" : "visible",
                  }}
                >
                  <Iconmoon icon="loop2" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
              {/* )} */}
            </>
          </SelectStyle>
          {record.lower_bound_percentage &&
            record.upper_bound_percentage &&
            record.toleranceLevel == "Job Card" ? (
            <span
              style={{
                marginLeft: "3px",
              }}
            >
              <>
                LB <strong>{record.lower_bound_percentage}%</strong>
                {"    "}
                UB <strong>{record.upper_bound_percentage}%</strong>
              </>
            </span>
          ) : (
            ""
          )}
        </>
      ),
    }, ,
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   width: "10%",
    // },
    {
      title: "Priority Orders",
      dataIndex: "priority_orders",
      width: "10%",
      align: "center",
    },
    {
      title: "Core Dia",
      width: "20%",
      render: (item, record) => (
        <span
          style={{
            width: "100%",
            display: "flex",
            height: "100%",
            justifyContent: "center",
          }}
        >
          {editMode && record === selectedRecord ? (
            <span>
              <Form.Item
                name="core_OD"
                rules={[]}
                className="selectForm"
                style={{ margin: "0px" }}
              >
                <Select
                  placeholder="Select Core Dia"
                  suffixIcon={<DownArrowDraw />}
                  showSearch
                  optionFilterProp="children"
                  onChange={handleCoreOD}
                  style={{ width: "100%" }}
                >
                  {coreValues?.map((data) => (
                    <Option key={data.value}>{data.value}</Option>
                  ))}
                </Select>
              </Form.Item>
              {isSaveButtonVisible && (
                <>
                  <Tooltip
                    placement="bottomRight"
                    title={"Save the entered value"}
                  >
                    <Button
                      key="1"
                      className="edit-btn"
                      style={{
                        padding: "0px",
                        margin: "0px",
                        width: "28px",
                        border: "none",
                        display: "inline-block",
                        marginRight: "10px",
                        backgroundColor: "transparent",
                      }}
                      onClick={() => handleSave()}
                    >
                      <Iconmoon icon="check" size={18} color="#3FBD61" />
                    </Button>
                  </Tooltip>
                </>
              )}
              <Tooltip
                placement="bottomLeft"
                title={"Remove the entered value"}
              >
                <Button
                  key="2"
                  className="edit-btn"
                  style={{
                    padding: "0px",
                    margin: "0px",
                    width: "28px",
                    border: "none",
                    display: "inline-block",
                    backgroundColor: "transparent",
                  }}
                  onClick={handleDiscard}
                >
                  <Iconmoon icon="cancel" size={18} color="red" />
                </Button>
              </Tooltip>
              {errorMessage && (
                <span
                  style={{ color: "red", fontSize: "11px", display: "block" }}
                >
                  {errorMessage}
                </span>
              )}
            </span>
          ) : (
            <span
              style={{
                marginLeft: "30px",
                width: "100%",
                display: "flex",
                height: "100%",
                minHeight: "30px",
                // position: "relative",
              }}
            >
              <span
                style={{
                  paddingTop: "5px",
                  // position: "absolute",
                  // right: "40%",
                }}
              >
                {item.core_id}{" "}
                {lengthUnit[data?.units?.core_id]?.displayName.toUpperCase()}
              </span>
              <Tooltip
                placement="bottomRight"
                title={"Edit Core ID"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button
                  onClick={() => {
                    handleEditColumn(true, record);
                  }}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    // float: "right",
                    // position: "absolute",
                    // right: "0",
                  }}
                >
                  <Iconmoon icon="edit" size={14} color="#A19F9D" />
                </Button>
              </Tooltip>
            </span>
          )}
        </span>
      ),
      align: "center",
    },

    {
      title: "Actions",
      dataIndex: "id",
      render: (id, record) => (
        <div className="actionBtn">
          {!record.merged && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Merge orders in this group"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => openMergeOrderDrawer(record)}>
                  {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                  <Iconmoon icon="refresh" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          {record.merged && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View Merged orders in this group"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => viewMergeHandler(record)}>
                  {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                  <Iconmoon icon="refresh" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View orders in this group"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={(e) => {
                  handleViewAction(record);
                  getCurrentScrollPositionByClick(e);
                }}
              >
                {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Remove this group"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => modalShow(id)}>
                <Iconmoon icon="delete" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const columnsHeadForCutting = [
    {
      title: "S.No",
      width: "11%",
      render: (text, record, index) => index + 1,

      align: "center",
    },
    {
      title: "Product Specfications",
      dataIndex: "product",
      width: "20%",
      // sorter: {
      //   compare: (a, b) => a.product_specfications - b.product_specfications,
      // },
      render: (data, record) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {data.product_spec}
          {record.merged && (
            <span className="taged" dataset="Produced">
              Merged Orders
            </span>
          )}
        </span>
      ),
    },

    // {
    //   title: "Core OD / Reel OD",
    //   width: "15%",
    //   // sorter: {
    //   //   compare: (a, b) => a.group.grouping_params.core_id.localeCompare(b.group.grouping_params.core_id),
    //   // },
    //   render: (data) => (
    //     <span>
    //       {data.core_id} CM/
    //       {data.reel_od} CM
    //     </span>
    //   ),
    // },
    {
      title: "Number of orders",
      dataIndex: "number_of_orders",
      width: "16%",
      sorter: {
        compare: (a, b) => a.number_of_orders - b.number_of_orders,
      },
      align: "center",
    },
    // {
    //   title: "Quantity",
    //   dataIndex: "quantity",
    //   width: "10%",
    //   render: (text, record) =>
    //     parseFloat(text) ? `${Math.ceil(text)} sheets` : null,
    // },
    {
      title: "Priority Orders",
      dataIndex: "priority_orders",
      width: "13%",
      align: "center",
    },
    {
      title: "Planned Weight",
      dataIndex: "weight",
      width: "13%",
      align: "left",
      render: (item) =>
        item
          ? item?.toFixed(3) +
          " " +
          capitalize(weightUnit[data?.units?.planned_weights]?.displayName)
          : null,
    },
    {
      title: "Actions",
      dataIndex: "id",
      render: (id, record) => (
        <div className="actionBtn">
          {!record.merged && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"Merge orders in this group"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => openMergeOrderDrawer(record)}>
                  {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                  <Iconmoon icon="refresh" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          {record.merged && (
            <Styled>
              <Tooltip
                placement="bottomRight"
                title={"View Merged orders in this group"}
                className="edit-tooltip"
                getPopupContainer={(triggerNode) => triggerNode}
              >
                <Button onClick={() => viewMergeHandler(record)}>
                  {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                  <Iconmoon icon="refresh" size={16} color="#A19F9D" />
                </Button>
              </Tooltip>
            </Styled>
          )}
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View orders in this group"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button
                onClick={(e) => {
                  handleViewAction(record);
                  getCurrentScrollPositionByClick(e);
                }}
              >
                {/* <Iconmoon icon="file-check" size={16} color="#A19F9D" /> */}

                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Remove this group"}
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <Button onClick={() => modalShow(id)}>
                <Iconmoon icon="delete" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ];

  const modalShow = (id) => {
    setSelectedId(id);
    setIsVisibleModal(true);
  };

  const modalClose = async () => {
    setSelectedId(null);
    setIsVisibleModal(false);
  };

  const closeMergeOrderDrawer = () => {
    nextClickRef.current = false;
    setMergeorderDrawer(false);
  };
  const closeViewMergeOrder = () => {
    nextClickRef.current = false;
    setViewMergedorderDrawer(false);
  };
  const openMergeOrderDrawer = (record) => {
    nextClickRef.current = true;
    setSelectedMergeOrderGroup(record);
    setMergeorderDrawer(true);
  };

  const viewMergeHandler = (record) => {
    nextClickRef.current = true;
    setCurrentViewMerge(record);
    setViewMergedorderDrawer(true);
  };

  const modalConfirm = async () => {
    const deleteResponse = await deleteGroup(selectedId);

    if (!deleteResponse.error) {
      let totalOrders = data.total_selected_orders;
      let totalQuantity = data.total_production_quantity;
      const newGroups = data.groups.filter((group) => {
        if (group.id != selectedId) return true;
        totalOrders -= group.number_of_orders;
        totalQuantity -= group.quantity;
        return false;
      });

      setData({
        groups: newGroups,
        total_production_quantity: totalQuantity,
        total_selected_orders: totalOrders,
        total_production_weight: deleteResponse.data.total_production_weight,
        units: deleteResponse.data.units,
      });
      setOrderSummaryTable((prevState) => ({
        ...prevState,
        state: {
          ...prevState.state,
          data: {
            groups: newGroups,
            total_production_quantity: totalQuantity,
            total_selected_orders: totalOrders,
            total_production_weight:
              deleteResponse.data.total_production_weight,
            units: deleteResponse.data.units,
          }, // <-- replace `newData` with your updated value
        },
      }));
      setFinalData({
        groups: newGroups,
        total_production_quantity: totalQuantity,
        total_selected_orders: totalOrders,
        total_production_weight: deleteResponse.data.total_production_weight,
        units: deleteResponse.data.units,
      });
      if (getMergeGroupsData()) {
        setMergeGroupsData({
          groups: newGroups,
          total_production_quantity: totalQuantity,
          total_selected_orders: totalOrders,
        });
      }
      setIsVisibleModal(false);
    }
  };

  const history = useNavigate();
  const routeChange = () => {
    history("../review-selected-order");
  };

  const checkZeroCoreGroup = () => {
    return data.groups.filter((gr) => gr.core_id == 0).length > 0;
  };
  const PrepareRouteChange = async () => {
    setLoadings(true);
    if (checkZeroCoreGroup() && location.state.processType == "multiStage") {
      setActionToaster({
        error: true,
        msg: "It is mandatory to have core dia for each group",
      });
      showToaster();
      setLoadings(false);
      return;
    }
    nextClickRef.current = true;
    isCancelJobCard.current = false;
    try {
      let selectedCutter = "";
      if (location.state.body.machine_type === "cutter") {
        let cutter = location.state.cutter_data.find(
          (data) => data.code === location.state.body.cutter_code
        );
        selectedCutter = cutter.type;
      }
      const body = {
        override_groups: stopCancelled,
      };
      const response =
        location.state.processType == "multiStage"
          ? await postGroupsMultistage(body)
          : location.state.body.machine_type === "cutter"
            ? selectedCutter == "simplex"
              ? await postSheetGroups(body)
              : await postDuplexGroups(body)
            : await postGroups(body);

      if (!response.error) setAcceptedJCGrpCode([]);
      // setRetainForm(true)
      // setFormObject(formValues);
      history("../preparing-job-card", {
        state: {
          jobCards: finalData,
          orderResponse: location.state.orderResponse,
          machine_type: location.state.body.machine_type,
          body: location.state.body,
          maximum_burst_factor: location.state.maximum_burst_factor,
          minimum_burst_factor: location.state.minimum_burst_factor,
          maximum_gsm: location.state.maximum_gsm,
          minimum_gsm: location.state.minimum_gsm,
          selected_rewinder: location.state.selected_rewinder,
          selected_cutter: location.state.selected_cutter,
          selected_rewinder_unit: location.state.selected_rewinder_unit,
          selected_cutter_unit: location.state.selected_cutter_unit,
          rewinder_data: location.state.rewinder_data,
          cutter_data: location.state.cutter_data,
          selected_type: location.state.selected_type,
          rewinder_minWidth: location.state.rewinder_minWidth,
          rewinder_maxWidth: location.state.rewinder_maxWidth,
          cutter_minWidth: location.state.cutter_minWidth,
          cutter_maxWidth: location.state.cutter_maxWidth,
          max_NoOfCutters: location.state.max_NoOfCutters,
          minWeight: location.state.minWeight,
          minWeight: location.state.minWeight,
          left_edge_trim: location.state.left_edge_trim,
          right_edge_trim: location.state.right_edge_trim,
          code: location.state.code,
          initital_OrderType: location.state.initital_OrderType,
          is_enabled: location.state.is_enabled,
          machine_code: location.state.machine_code,
          partitionWeightUnit: location.state.partitionWeightUnit,
          // groups: location.state.groups,
          max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
          left_edge_trim_cutter: location.state.left_edge_trim_cutter,
          right_edge_trim_cutter: location.state.right_edge_trim_cutter,
          processType: location.state.processType,
          isDummyJC: location.state.isDummyJC ?? false,
          so: location.state.so ?? null,
        },
      });
      setMergeGroupsData(null);
      // algorithmPollingStatus = setInterval(getStatus, 200);
    } catch (error) {
      // clearInterval(algorithmPollingStatus);
      setActionToaster({
        error: error.response.data.error,
        msg: error.response.data.msg,
      });
      showToaster();
      setLoadings(false);
      console.log(error);
    } finally {
    }
    // setTimeout(() => {
    //   history("../deckle-match-result");
    // }, 6200);
  };

  const showCancelModal = () => {
    setViewCancelModal(true);
  };

  const closeCancelModal = () => {
    setViewCancelModal(false);
  };
  const closeMergeModal = () => {
    setViewMergeModal(false);
  };
  const closeMergeMultipleModal = () => {
    setViewMergeMultipleModal(false);
    setMergeMultipleGroups(false);
  };
  const confirmCancelModal = () => {
    history("../job-cards");
    cancelJobCard();
    setStopCancelled(false);
    handleResetAll();
    setMergeGroupsData(null);
    setViewCancelModal(false);
    setFormObject(null);
  };
  const confirmSameMultipleCoreMerge = () => {
    setMergeMultipleGroups(true);
    setViewMergeMultipleModal(false);
  };
  const confirmSameCoreMerge = () => {
    handleSave(true);
  };

  const GoBackRouteChange = () => {
    // setRetainForm(true);
    cancelJobCard().then(() => {
      setStopCancelled(false);
      handleResetAll();
      if (location.state.type && location.state.type === "selectOrders") {
        history("../paper-machine-orders", {
          state: {
            body: location.state.body,
            maximum_burst_factor: location.state.maximum_burst_factor,
            minimum_burst_factor: location.state.minimum_burst_factor,
            maximum_gsm: location.state.maximum_gsm,
            minimum_gsm: location.state.minimum_gsm,
            selected_rewinder: location.state.selected_rewinder,
            selected_cutter: location.state.selected_cutter,
            selected_rewinder_unit: location.state.selected_rewinder_unit,
            selected_cutter_unit: location.state.selected_cutter_unit,
            rewinder_data: location.state.rewinder_data,
            cutter_data: location.state.cutter_data,
            selected_type: location.state.selected_type,
            rewinder_minWidth: location.state.rewinder_minWidth,
            rewinder_maxWidth: location.state.rewinder_maxWidth,
            cutter_minWidth: location.state.cutter_minWidth,
            cutter_maxWidth: location.state.cutter_maxWidth,
            max_NoOfCutters: location.state.max_NoOfCutters,
            minWeight: location.state.minWeight,
            minWeight: location.state.minWeight,
            left_edge_trim: location.state.left_edge_trim,
            right_edge_trim: location.state.right_edge_trim,
            code: location.state.code,
            initital_OrderType: location.state.initital_OrderType,
            is_enabled: location.state.is_enabled,
            machine_code: location.state.machine_code,
            partitionWeightUnit: location.state.partitionWeightUnit,
            max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
            left_edge_trim_cutter: location.state.left_edge_trim_cutter,
            right_edge_trim_cutter: location.state.right_edge_trim_cutter,
            processType: location.state.processType,
          },
        });
        isCancelJobCard.current = false;
        setMergeGroupsData(null);
      } else {
        isCancelJobCard.current = false;
        setMergeGroupsData(null);
        history("../paper-machine-selected-order", {
          state: {
            orderResponse: location.state.orderResponse,
            selected_rewinder: location.state.selected_rewinder,
            selected_cutter: location.state.selected_cutter,
            selected_rewinder_unit: location.state.selected_rewinder_unit,
            selected_cutter_unit: location.state.selected_cutter_unit,
            rewinder_data: location.state.rewinder_data,
            cutter_data: location.state.cutter_data,
            selected_type: location.state.selected_type,
            rewinder_minWidth: location.state.rewinder_minWidth,
            rewinder_maxWidth: location.state.rewinder_maxWidth,
            cutter_minWidth: location.state.cutter_minWidth,
            cutter_maxWidth: location.state.cutter_maxWidth,
            max_NoOfCutters: location.state.max_NoOfCutters,
            minWeight: location.state.minWeight,
            minWeight: location.state.minWeight,
            left_edge_trim: location.state.left_edge_trim,
            right_edge_trim: location.state.right_edge_trim,
            initital_OrderType: location.state.initital_OrderType,
            is_enabled: location.state.is_enabled,
            code: location.state.code,
            body: location.state.body,
            selectedRowKeys: location.state.selectedRowKeys,
            totalWeight: location.state.totalWeight,
            max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
            left_edge_trim_cutter: location.state.left_edge_trim_cutter,
            right_edge_trim_cutter: location.state.right_edge_trim_cutter,
            processType: location.state.processType,
            machine_code: location.state.machine_code,
          },
        });
      }
    }).catch((err) => {
      console.log(err);
    });
  };

  const searchGroups = async (value = "") => {
    if (value != "") {
      setSearchQuery(value);
      searchDeckleMatchGroups(value)
        .then((resp) => {
          setData({
            groups: resp.groups,
            total_production_quantity: resp.total_production_quantity,
            total_selected_orders: resp.total_selected_orders,
            total_production_weight: resp.total_production_weight,
            units: resp.units ? resp.units : {},
          });

          setOrderSummaryTable((prevState) => ({
            ...prevState,
            state: {
              ...prevState.state,
              data: {
                groups: resp.groups,
                total_production_quantity: resp.total_production_quantity,
                total_selected_orders: resp.total_selected_orders,
                total_production_weight: resp.total_production_weight,
                units: resp.units ? resp.units : {},
              }, // <-- replace `newData` with your updated value
            },
          }));
        })
        .catch((error) => console.log("Error in search", error));
    }
  };
  const confirmRemove = () => {
    seperateGroups()
      .then((resp) => {
        setConfirmRemoveGroups(false);
        setMergeGroupsData(null);
        setData({
          groups: resp.groups,
          total_production_quantity: resp.total_production_quantity,
          total_selected_orders: resp.total_selected_orders,
          total_production_weight: resp.total_production_weight,
          units: resp.units,
        });
        setOrderSummaryTable((prevState) => ({
          ...prevState,
          state: {
            ...prevState.state,
            data: {
              groups: resp.groups,
              total_production_quantity: resp.total_production_quantity,
              total_selected_orders: resp.total_selected_orders,
              total_production_weight: resp.total_production_weight,
              units: resp.units ? resp.units : {},
            }, // <-- replace `newData` with your updated value
          },
        }));
        setFinalData({
          groups: resp.groups,
          total_production_quantity: resp.total_production_quantity,
          total_selected_orders: resp.total_selected_orders,
          total_production_weight: resp.total_production_weight,
          units: resp.units,
        });
      })
      .catch((err) => { });
  };

  const cancelRemove = () => {
    setConfirmRemoveGroups(false);
    setViewMergedorderDrawer(true);
  };

  const showMergedRecords = (resp) => {
    setData({
      groups: resp.groups,
      total_production_quantity: resp.total_production_quantity,
      total_selected_orders: resp.total_selected_orders,
      total_production_weight: resp.total_production_weight,
      units: resp.units,
    });
    setOrderSummaryTable((prevState) => ({
      ...prevState,
      state: {
        ...prevState.state,
        data: {
          groups: resp.groups,
          total_production_quantity: resp.total_production_quantity,
          total_selected_orders: resp.total_selected_orders,
          total_production_weight: resp.total_production_weight,
          units: resp.units ? resp.units : {},
        }, // <-- replace `newData` with your updated value
      },
    }));
    setFinalData({
      groups: resp.groups,
      total_production_quantity: resp.total_production_quantity,
      total_selected_orders: resp.total_selected_orders,
      total_production_weight: resp.total_production_weight,
      units: resp.units,
    });
    setMergeGroupsData(resp);
    closeMergeOrderDrawer();
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const removeMergedGroups = () => {
    setViewMergedorderDrawer(false);
    setConfirmRemoveGroups(true);
  };
  const handleViewAction = (record) => {
    isCancelJobCard.current = false;
    nextClickRef.current = true;
    history("../review-selected-order", {
      state: {
        orders: [...record.orders],
        quantity: record.quantity,
        groupId: record.id,
        so: location?.state?.so,
        dummy_orders: location?.state?.dummy_orders,
        data: finalData,
        selected_type: location?.state?.selected_type,
        selected_rewinder: location.state.selected_rewinder,
        selected_cutter: location.state.selected_cutter,
        selected_rewinder_unit: location.state.selected_rewinder_unit,
        selected_cutter_unit: location.state.selected_cutter_unit,
        rewinder_data: location.state.rewinder_data,
        cutter_data: location.state.cutter_data,
        rewinder_minWidth: location.state.rewinder_minWidth,
        rewinder_maxWidth: location.state.rewinder_maxWidth,
        cutter_minWidth: location.state.cutter_minWidth,
        cutter_maxWidth: location.state.cutter_maxWidth,
        max_NoOfCutters: location.state.max_NoOfCutters,
        minWeight: location.state.minWeight,
        minWeight: location.state.minWeight,
        left_edge_trim: location.state.left_edge_trim,
        right_edge_trim: location.state.right_edge_trim,
        code: location.state.code,
        initital_OrderType: location.state.initital_OrderType,
        is_enabled: location.state.is_enabled,
        body: location.state.body,
        machine_code: location.state.machine_code,
        type: location.state.type,
        partitionWeightUnit: location.state.partitionWeightUnit,
        orderResponse: location.state.orderResponse,
        selectedRowKeys: location.state.selectedRowKeys,
        totalWeight: location.state.totalWeight,
        max_NoOfCutters_cutter: location.state.max_NoOfCutters_cutter,
        left_edge_trim_cutter: location.state.left_edge_trim_cutter,
        right_edge_trim_cutter: location.state.right_edge_trim_cutter,
        processType: location.state.processType,
        isDummyJC: location.state.isDummyJC ? true : false,
        so: location.state.so ?? null,

      },
    });
  };

  const handleMultiCoreSave = (coreId) => {
    setNewCoreId(coreId);
    handleSave(false, true, coreId);
  };
  const handleToleranceEditModalClose = () => {
    setVisibleTolerancePopUp(false);
  };
  useEffect(() => {
    headerForm.setFieldsValue({ core_OD: selectedCoreId });
  }, [selectedCoreId]);
  useEffect(() => {
    // Check if location.state.newGroupData exists
    // console.log(location?.state?.newGroupData);
    // console.log(data);
    // console.log(location.state.groupId, location.state.selectedQty);
    if (location.state && location.state.newGroupData) {
      setData(location.state.newGroupData);
      setFinalData(location.state.newGroupData);
    }
  }, []);
  useEffect(() => {
    let tempSum = 0;
    data?.groups?.map((group) => {
      tempSum += group.weight;
    });
    setSelectedQuantity(
      tempSum?.toFixed(3) +
      " " +
      (data?.units?.total_production_weight
        ? capitalize(
          weightUnit[data?.units?.total_production_weight]?.displayName
        )
        : "T")
    );
    const minReel = Math.min(...data.groups.map((gr) => gr.min_reel_od));
    setMinimumReelOdAllGroups(minReel);
  }, [data]);
  useEffect(() => {
    setScrollPosition((prevScrollPosition) => {
      return {
        ...prevScrollPosition,
        ...JSON.parse(window.localStorage.getItem("scrollCords")),
      };
    });
    window.scrollTo(scrollPosition.scrollX, scrollPosition.scrollY);
  }, [scrollPosition.scrollX, scrollPosition.scrollY]);

  useEffect(() => {
    mergeMultipleGroups !== null && handleSave(false, true, newCoreId);
  }, [mergeMultipleGroups]);

  useEffect(() => {
    return () => {
      if (!nextClickRef.current) {
        cancelJobCard();
        setStopCancelled(false);
        handleResetAll();
      }
      if (isCancelJobCard.current) {
        setFormObject(null);
        setMergeGroupsData(null);
      }
      if (!isViewClick.current)
        localStorage.setItem(
          "scrollCords",
          JSON.stringify({
            scrollX: 0,
            scrollY: 0,
          })
        );
    };
  }, []);
  useEffect(() => {
    (async () => {
      try {
        const response = await getReelCoreValues();
        const coreData = response?.core_data?.map((item) => {
          return {
            value: item[0] + " " + item[1],
          };
        });
        setCoreValues(coreData);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);
  useEffect(() => {
    if (Object.keys(orderSummaryTable).length > 0) return;
    setOrderSummaryTable(location);
  }, []);
  useEffect(() => {
    setIsSaveButtonVisible(errorMessage === "");
  }, [errorMessage]);
  return data ? (
    <RightLayoutContainer id="right-layout-container">
      <PageTitleComp ref={titleRef} style={{ borderBottom: "0", position: "sticky", top: stickyOffsets.title, zIndex: 100, backgroundColor: "#fff" }}>
        <PageHeader
          ghost={false}
          title="Selected Orders Summary"
          extra={[
            <Button
              key="1"
              className="textTypeBtn textBtnIcon"
              onClick={showCancelModal}
            >
              <Iconmoon
                icon="wrong"
                size={14}
                color="#EA4E2C"
                style={{ marginRight: "8px", top: "1px", position: "relative" }}
              />
              Cancel Job Card
            </Button>,
            !location.state.isDummyJC && (<Button
              key="1"
              className="themeBtn noBg noMargin"
              onClick={GoBackRouteChange}
            >
              Go Back
            </Button>),
            <Button
              key="1"
              className="themeBtn"
              onClick={PrepareRouteChange}
              loading={loadings}
              disabled={data?.groups?.length === 0 || isNextDisaled}
            >
              {!loadings && (
                <Iconmoon icon="move-right" size={14} color="#ffffff" />
              )}
              {!loadings ? "Next" : ""}
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>

      {showAlert && (
        <AlertContainer
          color={"green toaster"}
          icon={alertGreen}
          marginTop={"63px"}
          msg={"Selected orders are successfully merged"}
        />
      )}

      <TableLayoutData>
        <div className="tableDataFormat removePagnation">
          <OrderSummaryHeader
            placeholder={"Search product specifications"}
            fetchOrder={searchGroups}
            selected_type={location?.state?.selected_type}
            totalQuantity={selectedQuantity}
            coreValues={coreValues}
          />
          {location.state.processType == "multiStage" && (
            <div className="multiCoreContainer">
              <span className="coreIdText">Code Dia: </span>
              <HaberForm className="selectWidth">
                <Form form={headerForm}>
                  {" "}
                  <Form.Item
                    name="core_OD"
                    rules={[]}
                    className="selectForm"
                    style={{ margin: "0px", width: "200px" }}
                    initialValue={selectedCoreId}
                    onClick={() => setIsModalVisible(true)}
                  >
                    <Select
                      placeholder="Select Core Dia"
                      suffixIcon={<DownArrowDraw />}
                      showSearch
                      optionFilterProp="children"
                      onChange={handleMultiCoreOD}
                      style={{ width: "100%" }}
                    >
                      {coreValues?.map((data) => (
                        <Option key={data.value}>{data.value}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <p
                    style={{
                      color: "red",
                      width: "300px",
                      fontSize: "11px",
                      position: "absolute",
                    }}
                  >
                    {errorMessageMulti}
                  </p>
                </Form>
              </HaberForm>
            </div>
          )}
          {location?.state?.selected_type === "cutting" && (
            <PendingDetails>
              <div className="pendingDetailsStyle">
                <span className="pendingOrderStyle">
                  {" "}
                  Pending Orders: {"  "} {data?.total_selected_orders}
                </span>{" "}
                Planned Planned Qty:{" "}
                {data?.total_production_weight
                  ? data?.total_production_weight?.toFixed(3)
                  : 0}{" "}
                {capitalize(
                  weightUnit[data.units.total_production_weight]?.displayName
                )}
              </div>
            </PendingDetails>
          )}
          {isLoading ? (
            <TableShimmer
              header={
                location?.state?.selected_type === "cutting"
                  ? columnsHeadForCutting
                  : columnsHead
              }
            />
          ) : (
            <Table
              rowKey={(record) => record.id}
              columns={
                location?.state?.selected_type === "cutting"
                  ? columnsHeadForCutting
                  : columnsHead
              }
              dataSource={data.groups}
              onChange={onChange}
              pagination={false}
              scroll={{ x: 'max-content' }}
              sticky={{
                offsetHeader: stickyOffsets.table,
                getContainer: () => {
                  let node = document.getElementById('right-layout-container');
                  while (node && node !== document.body) {
                    const style = window.getComputedStyle(node);
                    if (style.overflowY === 'auto' || style.overflowY === 'scroll') return node;
                    node = node.parentNode;
                  }
                  return window;
                }
              }}
            />
          )}
        </div>
      </TableLayoutData>

      {/* {location?.state?.selected_type !== "cutting" && (
        <span className="textTypeBtn textBtnIcon tonnesCount">
          {" "}
          Total Production Quantity of listed orders is{" "}
          {data.total_production_quantity} Reels
        </span>
      )} */}

      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Remove Group?</span>
          <p>
            You are about to remove this order group, are you sure you want to
            continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>

      <ConfirmationModal
        visible={viewCancelModal}
        icon={warning}
        confirmAction={confirmCancelModal}
        cancelAction={closeCancelModal}
      >
        <span>Cancel job card?</span>
        <p>
          You are about to cancel the deckle match process. Are you sure you
          want to continue?
        </p>
      </ConfirmationModal>
      <ConfirmationModal
        visible={viewMergeModal}
        icon={warning}
        confirmAction={confirmSameCoreMerge}
        cancelAction={closeMergeModal}
      >
        <span>Are you sure?</span>
        <p>
          There is a group with similar product specifications and core
          diameter. These orders will also be merged with that group. Are you
          sure you want to continue?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={viewMergeMultipleModal}
        icon={warning}
        confirmAction={confirmSameMultipleCoreMerge}
        cancelAction={closeMergeMultipleModal}
        isOrderSummaryMerge={true}
      >
        <span>Merge groups?</span>
        <p>
          There is/are one or more groups with similar product specifications
          and core diameter. Do you want to merge those groups?
        </p>
      </ConfirmationModal>

      <ConfirmationModal
        visible={confirmRemoveGroups}
        icon={warning}
        confirmAction={confirmRemove}
        cancelAction={cancelRemove}
      >
        <span>Separate Orders?</span>
        <p>
          All orders in this group will be separated into individual groups. Are
          you sure you want to continue ?
        </p>
      </ConfirmationModal>
      {mergeorderDrawer && (
        <MergedOrder
          visible={mergeorderDrawer}
          onCloseMergeOrderDrawer={closeMergeOrderDrawer}
          selectedGroup={selectedMergeOrderGroup}
          updateTable={showMergedRecords}
          maximum_burst_factor={location.state.maximum_burst_factor}
          minimum_burst_factor={location.state.minimum_burst_factor}
          maximum_gsm={location.state.maximum_gsm}
          minimum_gsm={location.state.minimum_gsm}
          convertingMachineType={location?.state?.selected_type}
          units={data.units}
        />
      )}
      <ViewMergeDrawer
        visible={viewMergedorderDrawer}
        onCloseMergeOrderDrawer={closeViewMergeOrder}
        currentGroup={currentViewMerge}
        updateTable={removeMergedGroups}
        selectedGroup={selectedMergeOrderGroup}
        units={data?.units}
      />
      {visibleToaster && !actionToaster.error && (
        <AlertContainer
          color="green toaster"
          icon={alertGreen}
          msg={actionToaster.msg}
          marginTop={"63px"}
        />
      )}
      {visibleToaster && actionToaster.error && (
        <AlertContainer
          color="red toaster"
          icon={alertRed}
          msg={actionToaster.msg}
          marginTop={"63px"}
        />
      )}
      {visibleTolerancePopUp && (
        <ToleranceEditModal
          visible={visibleTolerancePopUp}
          confirmAction={() => setVisibleTolerancePopUp(false)}
          cancelAction={() => handleToleranceEditModalClose()}
          groupData={selectedRecord}
          toleranceLevelType={selectedToleranceLevelType}
          setActionToaster={() => setActionToaster()}
          data={data}
          finalData={finalData}
          orderSummaryTable={orderSummaryTable}
          setData={setData}
          setFinalData={setFinalData}
          setOrderSummaryTable={setOrderSummaryTable}
        />
      )}
    </RightLayoutContainer>
  ) : null;
};

export default OrderSummaryData;
